import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/store";
import { useKeywordsApi } from "../api";
import { resetError, setError, setLoading } from "../slices";
import { CreateKeywordRequestData, UpdateKeywordRequestData } from "../types";

export const useKeywordService = () => {
  const dispatch = useDispatch();
  const { loading, error } = useAppSelector((state) => state.keywords);

  const api = useKeywordsApi();

  const createKeyword = useCallback(async (companyId: string, data: CreateKeywordRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ create: true }));

      await api.createKeyword(companyId, data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ create: false }));
    }
  }, []);

  const updateKeyword = useCallback(async (companyId: string, keywordId: string, data: UpdateKeywordRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ update: true }));

      await api.updateKeyword(companyId, keywordId, data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ update: false }));
    }
  }, []);

  const deleteKeyword = useCallback(async (companyId: string, keywordId: string) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ delete: true }));

      await api.deleteKeyword(companyId, keywordId);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ delete: false }));
    }
  }, []);

  return {
    loading,
    error,
    createKeyword,
    updateKeyword,
    deleteKeyword,
  };
};
